const logOut = (href = '/') => {
  window.localStorage.setItem('satellizer_token', '');
  window.location.href = href;
};

export default logOut;
